export const breakpoint = {
  mobileSmall: '576px',
  mobile: '767px',
  tablet: '980px',
  monitor: '1280px',
  widescreen: '1690px'
};
